"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.isAppDisabled = void 0;

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url"));

var _ILoading = require("../../models/ILoading");

var isAppDisabled = function isAppDisabled(props, appSuiteState) {
  var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.location;

  if (process.env.APP_SUITE_ENABLED !== 'true' || !process.env.APP_SUITE_APP_KEY || !props.notAuthorizedMessage) {
    return false;
  }

  var loc = new _url.default(location.href);

  if (process.env.NODE_ENV === 'development' && loc.searchParams.get('enableCheck') !== 'true') {
    return false;
  }

  return appSuiteState.enabledApps.loadingState === _ILoading.LoadingState.loaded && !appSuiteState.enabledApps.value[process.env.APP_SUITE_APP_KEY];
};

exports.isAppDisabled = isAppDisabled;